import * as _ from "lodash-es";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { NumericFormat } from "react-number-format";
import IDeleteCatalogItemDTO from "@models/DTO/IDeleteCatalogItemDTO";
import IElasticSearchSyncCatalogDTO from "@models/DTO/IElasticSearchSyncCatalogDTO";
import IErrorDTO from "@models/DTO/IErrorDTO";
import IGetCatalogItemsDTO from "@models/DTO/IGetCatalogItemsDTO";
import IGetVendorSourcesDTO from "@models/DTO/IGetVendorSourcesDTO";
import IOnDeleteCatalogItemDTO from "@models/DTO/IOnDeleteCatalogItemDTO";
import IOnElasticSearchSyncCatalogDTO from "@models/DTO/IOnElasticSearchSyncCatalogDTO";
import IOnGetCatalogItemsDTO from "@models/DTO/IOnGetCatalogItemsDTO";
import IOnGetVendorSourcesDTO from "@models/DTO/IOnGetVendorSourcesDTO";
import IOnQBDCreateCatalogItemsDTO from "@models/DTO/IOnQBDCreateCatalogItemsDTO";
import IOnQBDMapperDTO from "@models/DTO/IOnQBDMapperDTO";
import IOnQBDPushItemsDTO from "@models/DTO/IOnQBDPushItemsDTO";
import IOnUpdateUserSettingsDTO from "@models/DTO/IOnUpdateUserSettingsDTO";
import IQBDCreateCatalogItemsDTO from "@models/DTO/IQBDCreateCatalogItemsDTO";
import IQBDMapperDTO from "@models/DTO/IQBDMapperDTO";
import IQBDPushItemsDTO from "@models/DTO/IQBDPushItemsDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import IAction from "@models/IAction";
import IBreadcrumbs from "@models/IBreadcrumbs";
import ICatalog from "@models/ICatalog";
import ICatalog_Item from "@models/ICatalog_Item";
import ICatalog_ItemUI from "@models/ICatalog_ItemUI";
import ICategory from "@models/ICategory";
import IColumns from "@models/IColumns";
import IDataMapperSaveItem from "@models/IDataMapperSaveItem";
import INotification from "@models/INotification";
import IOwTableCols from "@models/IOwTableCols";
import IPrice_Group from "@models/IPrice_Group";
import ISupplierModel from "@models/ISupplierModel";
import IUserUI from "@models/IUserUI";
import IVendor_Source from "@models/IVendor_Source";
import NotificationLevelEnum from "@models/NotificationLevelEnum";
import NotificationPositionEnum from "@models/NotificationPositionEnum";
import ResourceTypesEnum from "@models/ResourceTypesEnum";
import SortOrderEnum from "@models/SortOrderEnum";
import Breadcrumbs from "@components/shared/Breadcrumbs/Breadcrumbs";
import IntegrationsConnectedBar from "@components/shared/IntegrationsConnectedBar/IntegrationsConnectedBar";
import OwActionBar from "@components/shared/OwActionBar/OwActionBar";
import OwButton from "@components/shared/OwButton/OwButton";
import { OwDataMapper } from "@components/shared/OwDataMapper/OwDataMapper";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTable from "@components/shared/OwTable/OwTable";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import PaginationBar from "@components/shared/PaginationBar/PaginationBar";
import { CatalogItemFilter } from "@components/catalogs/CatalogOverview/CatalogItemFilter/CatalogItemFilter";
import "./CatalogOverview.scss";
import CategorySidebar from "./CategorySidebar/CategorySidebar";
import CreateCatalogItemSidebar from "./CreateCatalogItemSidebar/CreateCatalogItemSidebar";
import InventoryRowConfig from "./InventoryRowConfig/InventoryRowConfig";
import OrderRowConfig from "./OrderRowConfig/OrderRowConfig";
import PriceGroupSidebar from "./PriceGroupSidebar/PriceGroupSidebar";
import wayfairIcon from "../../../assets/images/wayfair/wayfair-icon.svg";
import { QBDItemSyncPriceGroupSelectionModal } from "./QBDItemSyncPriceGroupSelectionModal/QBDItemSyncPriceGroupSelectionModal";
import Modal from "react-modal";
import IImageSizeEnum from "@models/IImageSizeEnum";
import OwS3ImageViewer from "@components/shared/OwS3ImageViewer/OwS3ImageViewer";
import { Socket } from "socket.io-client";
import IOnGetPriceGroupsDTO from "@models/DTO/IOnGetPriceGroupsDTO";
import ICatalogDeletePriceGroupDTO from "@models/DTO/ICatalogDeletePriceGroupDTO";
import ICatalogOnDeletePriceGroupDTO from "@models/DTO/ICatalogOnDeletePriceGroupDTO";
import { QBDItemsSyncStatus } from "./QBDItemsSyncStatus/QBDItemsSyncStatus";
import OwPill from "@components/shared/OwPill/OwPill";
import IUiSocketSetup from "@models/IUiSocketSetup";
import IQBDOnGetXmlDTO from "@models/DTO/IQBDOnGetXmlDTO";
import IQBDGetXmlDTO from "@models/DTO/IQBDGetXmlDTO";
import IUpdateTokenSettingsDTO from "@models/DTO/IUpdateTokenSettingsDTO";
import UserService from "@services/UserService";
import { OwDeleteEditActions } from "@components/shared/OwDeleteEditActions/OwDeleteEditActions";
import { ConfirmDeleteOverlayFn } from "@components/shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import HelperService from "@services/HelperService";
import { PriceBandPriceDisplay } from "@components/shared/PriceBandPriceDisplay/PriceBandPriceDisplay";
import { SearchSection } from "@components/shared/SearchSection/SearchSection";
import IOnDuplicateCatalogItemDTO from "@models/DTO/IOnDuplicateCatalogItemDTO";
import IDuplicateCatalogItemDTO from "@models/DTO/IDuplicateCatalogItemDTO";
import { CloneCatalogItemModal } from "./CloneCatalogItemModal/CloneCatalogItemModal";
import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";

type Props = {
    match: any;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    showHiddenFeatures: boolean;
    isReadOnly: boolean;
};

type State = {
    navItems: IBreadcrumbs[];
    catalog_items: ICatalog_ItemUI[];
    totalCatalogItems: number;
    offset: number;
    limit: number;
    clearPriceGroupData: boolean;
    supplierIntegrations?: any;
    catalogGuid: string;
    priceGroups?: IPrice_Group[];
    queryString?: any;
    catalogModel?: ICatalog;
    clearCategoryData: boolean;
    categories?: ICategory[];
    dataFetched: boolean;
    createPriceGroups: boolean;
    updatePriceGroups: boolean;
    sortCol: string;
    sortDir: SortOrderEnum;
    isSmallTable: boolean;
    columns: IColumns;
    actions: IAction[];
    qbdSelectableOptions: any[];
    qbdStaticOptions: any[];
    qbdMapperVisible: boolean;
    isLoading: boolean;
    showOrderRowConfig: boolean;
    showInventoryRowConfig: boolean;
    isDataFetching: boolean;
    isInitialData: boolean;
    tableColumns: IOwTableCols[];
    qbdItemSyncActive: boolean;
    syncElasticSearch: boolean;
    vendorSources: IVendor_Source[];
    sourceElem?: HTMLElement | null;
    sourceCatalogItem?: ICatalog_ItemUI;
    modalIsOpen: boolean;
    modalComponent: any;
    isPhotoView: boolean;
    deleteElem: string | null;
};

/**
 * @deprecated
 *
 * This component is deprecated and will be removed in the future.
 *
 * Use CatalogOverviewFn instead.
 *
 * @see CatalogOverviewFn
 * @see CatalogOverviewWrapper
 * @see CatalogOverviewFn
 */
class CatalogOverview extends Component<Props, State> {
    confirmDeleteRef: any;

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        document.title = `Orderwerks >> Catalogs >> Catalog Overview`;

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        const userCols = currentToken?.settings?.catalog_cols || {};

        const getColumnChecked = (objProp: string, defaultVal: boolean) => {
            let isChecked = defaultVal;

            if (!_.isNil(userCols) && !_.isNil(userCols[objProp])) {
                isChecked = userCols[objProp];
            }

            return isChecked;
        };

        const state: State = {
            navItems: [],
            catalog_items: [],
            totalCatalogItems: 0,
            offset: 0,
            limit: 10,
            clearPriceGroupData: false,
            clearCategoryData: false,
            catalogGuid: "",
            dataFetched: false,
            createPriceGroups: false,
            updatePriceGroups: false,
            isPhotoView: false,
            sortCol: "name",
            sortDir: SortOrderEnum.ASC,
            queryString: `?order_dir=${SortOrderEnum.ASC}&order_by=name`,
            isSmallTable: true,
            columns: {
                actions: { name: "actions", label: "", isChecked: getColumnChecked("actions", true), notVisible: true },
                active: { name: "active", label: "active", isChecked: getColumnChecked("active", true) },
                category: { name: "category", label: "category", isChecked: getColumnChecked("category", true) },
                type: { name: "type", label: "type", isChecked: getColumnChecked("type", true) },
                name: { name: "name", label: "name", isChecked: getColumnChecked("name", true) },
                sku: { name: "sku", label: "sku", isChecked: getColumnChecked("sku", true) },
                inventory: { name: "inventory", label: "inventory", isChecked: getColumnChecked("inventory", true) },
                short_description: {
                    name: "short_description",
                    label: "short_description",
                    isChecked: getColumnChecked("short_description", true),
                },
                description: { name: "description", label: "description", isChecked: getColumnChecked("description", true) },
                msrp: { name: "msrp", label: "msrp", isChecked: getColumnChecked("msrp", true) },
                map: { name: "map", label: "map", isChecked: getColumnChecked("map", true), notVisible: !this.props.supplierModel.has_map },
                pricing: { name: "price_groups", label: "price_groups", isChecked: getColumnChecked("pricing", true) },
                uom: { name: "unit_of_measurement", label: "uom", isChecked: getColumnChecked("uom", true) },
                integrations: {
                    name: "integrations",
                    label: "integrations",
                    isChecked: getColumnChecked("integrations", false),
                    notVisible: false,
                },
            },
            actions: [],
            qbdSelectableOptions: [],
            qbdStaticOptions: [],
            qbdMapperVisible: false,
            isLoading: true,
            showOrderRowConfig: false,
            showInventoryRowConfig: false,
            isDataFetching: false,
            isInitialData: true,
            tableColumns: [],
            qbdItemSyncActive: false,
            syncElasticSearch: false,
            vendorSources: [],
            modalIsOpen: false,
            modalComponent: null,
            deleteElem: null,
        };

        this.state = state;

        this.sockets = [
            { endpoint: EndpointsEnum.CatalogItemOnGetCatalogItems, fn: this.onGetCatalogItems },
            { endpoint: EndpointsEnum.CatalogItemOnUpdateCatalogItem, fn: this.reloadCatalogItems },
            { endpoint: EndpointsEnum.CatalogItemOnCreateCatalogItem, fn: this.reloadCatalogItems },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.CatalogsOnCreatePriceGroup, fn: this.onCreatePriceGroup },
            { endpoint: EndpointsEnum.CatalogsOnUpdatePriceGroup, fn: this.onUpdatePriceGroup },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalog, fn: this.onGetCatalog },
            { endpoint: EndpointsEnum.QBDOnMapper, fn: this.onQbdMapper },
            { endpoint: EndpointsEnum.QBDOnCreateCatalogItems, fn: this.onQbdCreateCatalogItems },
            { endpoint: EndpointsEnum.ElasticSearchOnSyncCatalog, fn: this.onElasticSearchSyncCatalog },
            { endpoint: EndpointsEnum.QBDOnPushItems, fn: this.onQBDPushItems },
            { endpoint: EndpointsEnum.PurchaseOrderOnGetVendorSources, fn: this.onGetVendorSources },
            { endpoint: EndpointsEnum.CatalogItemOnDeleteCatalogItem, fn: this.onDeleteCatalogItem },
            { endpoint: EndpointsEnum.TokenOnUpdateSettings, fn: this.onUpdateTokenSettings },
            { endpoint: EndpointsEnum.CatalogsOnDeletePriceGroup, fn: this.onDeletePriceGroup },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.QBDOnGetXML, fn: this.onQbdGetXml },
        ];
    }

    async componentDidMount() {
        const catalogGuid = this.props.match.params.guid;

        const navItems = [
            { title: "catalogs", url: "/catalogs" },
            { title: "catalog_overview", url: `/catalogs/${catalogGuid}` },
        ];

        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        let supplierIntegrations = {};

        if (!_.isNil(this.props.supplierModel)) {
            supplierIntegrations = this.props.supplierModel.Supplier_Integration || {};
        }

        const actions: IAction[] = [
            {
                name: "price_groups",
                leftIconClass: "fad fa-dollar-sign",
                fn: this.openPriceGroupsSidebar,
                isActive: false,
                id: "price_groups",
            },
            {
                name: "categories",
                leftIconClass: "fad fa-layer-group",
                fn: this.openCategoriesSidebar,
                isActive: false,
                id: "categories",
            },
        ];

        if (this.props.supplierModel.has_home_categories) {
            actions.push({
                name: "home_categories",
                leftIconClass: "fad fa-layer-group",
                fn: this.openHomeCategoriesSidebar,
                isActive: false,
                id: "home_categories",
            });
        }

        actions.push(
            {
                name: "order_row_config",
                leftIconClass: "fad fa-columns",
                fn: this.openOrderRowConfigModal,
                isActive: false,
                isOpen: () => {
                    return this.state.showOrderRowConfig;
                },
                id: "order_row_config",
            },
            {
                name: "inventory_row_config",
                leftIconClass: "fad fa-columns",
                fn: this.openInventoryRowConfigModal,
                isActive: false,
                isOpen: () => {
                    return this.state.showInventoryRowConfig;
                },
                id: "inventory_row_config",
            }
        );

        if (this.props.supplierModel.has_purchase_orders) {
            this.getVendorSources();
        }

        actions.push({
            leftIconClass: "fad fa-sync",
            name: "sync_elasticsearch",
            isActive: () => {
                return this.state.syncElasticSearch;
            },
            fn: this.syncElasticSearch,
            btnClass: () => {
                return this.props.showHiddenFeatures ? "btn btn-primary" : "btn btn-primary d-none";
            },
        });

        if (this.props.supplierModel.Supplier_Integration.has_qbd) {
            // if (this.props.supplierModel.Supplier_Integration.qbd_CatalogItems) {
            const quickbooksMappingAction: IAction = {
                name: "items_map",
                leftIconClass: "fad fa-exchange",
                fn: this.openQuickBooksMapping,
                isActive: false,
            };

            const quickbooksItemSync: IAction = {
                name: "items_sync",
                leftIconClass: "fad fa-link",
                fn: this.showQbdItemSyncPriceGroupSelectionModal,
                isActive: () => {
                    return this.state.qbdItemSyncActive;
                },
            };

            const quickbooksItemPush: IAction = {
                name: "items_push",
                leftIconClass: "fad fa-cloud-upload-alt",
                fn: this.pushQBDItems,
                isActive: () => {
                    return this.state.qbdItemSyncActive;
                },
            };

            const quickBooksGetXml: IAction = {
                name: "get_xml",
                leftIconClass: "fad fa-file-code",
                fn: this.getXml,
                isActive: false,
                btnClass: () => {
                    return this.props.showHiddenFeatures ? "btn btn-primary" : "btn btn-primary d-none";
                },
            };

            const qbdGroup: IAction = {
                isGroup: true,
                name: "quickbooks_desktop",
                groupActions: [quickbooksMappingAction, quickbooksItemSync, quickbooksItemPush, quickBooksGetXml],
            };

            actions.push(qbdGroup);
            // }
        }

        const qbdSelectableOptions = this.getQbdSelectableOptions();

        this.setState(
            {
                navItems,
                supplierIntegrations,
                catalogGuid,
                priceGroups: [],
                actions,
                qbdSelectableOptions,
            },
            () => {
                this.loadCatalogOverview();
            }
        );
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (!this.props.showHiddenFeatures) {
            // console.log('window', window);

            // @ts-expect-error
            if (!_.isNil(window.showHiddenFeatures) && window.showHiddenFeatures) {
                this.setState(
                    {
                        showHiddenFeatures: true,
                    },
                    () => {
                        const actions = this.state.actions;

                        console.log("show hidden features, and set actions");

                        this.setState({
                            actions,
                        });
                    }
                );
            }
        }
    }

    setupTableColumns = () => {
        const tableColumns: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: this.renderActionsCol,
                renderFnEmitsRow: true,
                className: "w-15r",
            },
        ];

        if (this.state.columns.active.isChecked) {
            tableColumns.push({
                title: "active",
                valueProp: "active",
                renderFn: this.renderActiveCol,
                className: "text-center",
            });
        }

        if (this.state.columns.category.isChecked) {
            tableColumns.push({
                title: "category",
                valueProp: "category",
                renderFn: this.renderCategoryCol,
                renderFnEmitsRow: true,
                className: "text-center",
                sortOrderFn: () => {
                    return this.state.sortDir;
                },
                sortFn: this.toggleSortDir,
                isSortable: true,
            });
        }

        if (this.state.columns.type.isChecked) {
            tableColumns.push({
                title: "type",
                valueProp: "type",
                renderFn: this.renderTypeCol,
                renderFnEmitsRow: true,
                className: "text-center",
                // sortOrderFn: () => {
                //     return this.state.sortDir;
                // },
                // sortFn: this.toggleSortDir,
                isSortable: false,
            });
        }

        tableColumns.push({
            renderFn: this.renderPhotoCol,
            renderFnEmitsRow: true,
            title: "",
            valueProp: "",
            isChecked: () => {
                return this.state.isPhotoView;
            },
        });

        if (this.state.columns.name.isChecked) {
            tableColumns.push({
                renderFnEmitsRow: true,
                title: "name",
                valueProp: "name",
                sortOrderFn: () => {
                    return this.state.sortDir;
                },
                sortFn: this.toggleSortDir,
                isSortable: true,
            });
        }

        if (this.state.columns.sku.isChecked) {
            tableColumns.push({
                title: "sku",
                valueProp: "sku",
                renderFn: this.renderSkuCol,
                renderFnEmitsRow: true,
                sortOrderFn: () => {
                    return this.state.sortDir;
                },
                sortFn: this.toggleSortDir,
                isSortable: true,
            });
        }

        if (this.state.columns.inventory.isChecked) {
            tableColumns.push({
                title: "inventory",
                valueProp: "qty_on_hand",
                isSortable: false,
                renderFn: this.renderInventoryCol,
                renderFnEmitsRow: true,
            });
        }

        if (this.state.columns.short_description.isChecked) {
            tableColumns.push({
                title: "short_description",
                valueProp: "short_description",
                renderFn: this.renderShortDescriptionCol,
                renderFnEmitsRow: true,
            });
        }

        if (this.state.columns.description.isChecked) {
            tableColumns.push({
                title: "description",
                valueProp: "description",
                renderFn: this.renderDescriptionCol,
                renderFnEmitsRow: true,
            });
        }

        if (this.state.columns.msrp.isChecked) {
            tableColumns.push({
                title: "msrp",
                valueProp: "msrp",
                className: "text-center",
                renderFn: this.renderMsrpCol,
                renderFnEmitsRow: true,
            });
        }

        if (this.state.columns.map.isChecked && this.props.supplierModel.has_map) {
            tableColumns.push({
                title: "MAP",
                valueProp: "map",
                className: "text-center",
                renderFn: this.renderMapCol,
                renderFnEmitsRow: true,
            });
        }

        // column names for each price group

        if (this.state.priceGroups && this.state.columns.pricing.isChecked) {
            for (const priceGroup of this.state.priceGroups) {
                tableColumns.push({
                    title: _.startCase(priceGroup.value),
                    valueProp: "",
                    skipTitleTranslate: true,
                    renderFn: (row: ICatalog_ItemUI, rowIndex: number) => {
                        return this.renderPriceGroupCol(row, rowIndex, priceGroup);
                    },
                    renderFnEmitsRow: true,
                    className: "text-left",
                });
            }
        }

        if (this.state.columns.uom.isChecked) {
            tableColumns.push({
                title: "uom",
                valueProp: "",
                renderFn: this.renderUnitOfMeasurementCol,
                renderFnEmitsRow: true,
                className: "text-center",
            });
        }

        if (this.state.columns.integrations.isChecked) {
            tableColumns.push({
                title: "integrations",
                valueProp: "",
                renderFn: this.renderIntegrationsCol,
                renderFnEmitsRow: true,
            });
        }

        this.setState({
            tableColumns,
        });
    };

    notify = (data: IErrorDTO) => {
        this.props.setActivityIndicator(false);

        this.props.notifyFn(data);
    };

    getXml = () => {
        const payload: IQBDGetXmlDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            type: "CATALOG",
            typeGuid: this.state.catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.QBDGetXML, payload);
    };

    onQbdGetXml = (data: IQBDOnGetXmlDTO) => {
        console.log(data.xmlData);
    };

    syncElasticSearch = () => {
        const payload: IElasticSearchSyncCatalogDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.ElasticSearchSyncCatalog, payload);

        this.setState({
            syncElasticSearch: true,
        });
    };

    onElasticSearchSyncCatalog = (data: IOnElasticSearchSyncCatalogDTO) => {
        this.setState({
            syncElasticSearch: false,
        });
    };

    toggleConfirmDelete = (row: ICatalog_ItemUI, index: number) => {
        const sourceElem = document.getElementById(`row-${index}`);

        this.setState({
            sourceElem,
            sourceCatalogItem: row,
            deleteElem: `row-${index}`,
        });
    };

    cancelDelete = () => {
        this.setState({
            sourceElem: null,
            sourceCatalogItem: undefined,
            deleteElem: null,
        });
    };

    confirmDelete = () => {
        if (this.state.sourceCatalogItem) {
            this.deleteCatalogItem(this.state.sourceCatalogItem);
        }
    };

    deleteCatalogItem = (item: ICatalog_Item) => {
        const payload: IDeleteCatalogItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
            catalogItemGuid: item.guid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemDeleteCatalogItem, payload);

        this.setState({
            sourceElem: null,
            sourceCatalogItem: undefined,
            deleteElem: null,
        });
    };

    onDeleteCatalogItem = (data: IOnDeleteCatalogItemDTO) => {
        const notification: INotification = {
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
            message: "successfully_deleted_catalog_item",
        };

        this.props.notifyFn(null, notification);

        this.getCatalogItems();
    };

    cloneItem = (row: ICatalog_ItemUI, index: number) => {
        const modalComponent = <CloneCatalogItemModal item={row} closeModal={this.closeModal} />;

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    renderPhotoCol = (row: ICatalog_ItemUI, index: number) => {
        return this.state.isPhotoView ? (
            <div>
                <OwS3ImageViewer
                    catalogItem={row}
                    isMicroView={true}
                    attachmentIndex={0}
                    imageIndex={IImageSizeEnum.THUMB}
                    className={"me-2 mb-2 mb-md-0"}
                    includeAllImages={true}
                    hideEmptyImage={true}
                />
            </div>
        ) : null;
    };

    renderActionsCol = (row: ICatalog_ItemUI, index: number) => {
        let hasMainImage = false;

        for (const attachment of row.Attachments || []) {
            if (attachment.image_seq === 1) {
                hasMainImage = true;
            }
        }

        let hasProductGroup = false;

        if (row?.is_product_group) {
            hasProductGroup = true;
        }

        let hasFiles = false;

        if (row?.Attachments?.length) {
            hasFiles = true;
        }

        let hasAlternateSourcing = false;

        if (row?.has_alternate_sourcing) {
            hasAlternateSourcing = true;
        }

        let hasInventory = false;

        if (row?.has_inventory) {
            hasInventory = true;
        }

        let hasWarehouses = false;

        if ((row?.Warehouse_Catalog_Items_Maps || []).length) {
            hasWarehouses = true;
        }

        let hasWayfair = false;

        if (row.wayfair_item) {
            hasWayfair = true;
        }

        let readOnly = false;

        // @ts-expect-error
        // console.log(this.props.supplierModel.settings.screen_options.catalogs, this.props.userModel.supplierUserToken.user_type_id, this.props.supplierModel.settings.screen_options.catalogs[this.props.userModel.supplierUserToken.user_type_id].EDIT);

        if (this.props.supplierModel.settings) {
            if (!_.isString(this.props.supplierModel.settings)) {
                if (this.props.supplierModel.settings.screen_options?.catalogs) {
                    if (
                        this.props.userModel.supplierUserToken?.user_type_id &&
                        // @ts-expect-error
                        !this.props.supplierModel.settings.screen_options.catalogs[this.props.userModel.supplierUserToken.user_type_id].EDIT
                    ) {
                        readOnly = true;
                    }
                }
            }
        }

        if (readOnly) {
            return null;
        } else {
            return (
                <div className={"info-icons d-flex align-items-center"}>
                    <span className={"state-circle me-4 " + (row.isSaved ? "bluish-green-bg" : "red-bg")} />
                    <OwDeleteEditActions
                        isEditMode={false}
                        onEditClickFn={(e) => {
                            this.openCatalogItemSidebar(row, index);
                        }}
                        onTrashClickFn={() => {
                            this.toggleConfirmDelete(row, index);
                        }}
                    />
                    <span className="ms-2 me-2">
                        <OwButton
                            centerIconClass="fad fa-clone"
                            fn={() => {
                                this.cloneItem(row, index);
                            }}
                            hoverTitle="Clone"
                        />
                    </span>
                    <span className={"col-auto .g-0 item-has-image"}>
                        <i title={"Has Image?"} className={"far fa-image ms-md-4 " + (hasMainImage ? "text-warning" : "text-muted")}></i>
                    </span>
                    {/*<span className={"col-auto .g-0 item-is-product-group"}>*/}
                    {/*    <i*/}
                    {/*        title={"Product Group?"}*/}
                    {/*        className={"fad fa-sitemap ms-md-2 " + (hasProductGroup ? "text-primary" : "text-muted")}></i>*/}
                    {/*</span>*/}
                    <span className={"col-auto .g-0 item-has-spec-file"}>
                        <i title={"Files?"} className={"fad fa-file-alt ms-md-2 " + (hasFiles ? "text-primary" : "text-muted")}></i>
                    </span>
                    {/*<span className={"col-auto .g-0 item-has-inventory"}>*/}
                    {/*    <i*/}
                    {/*        title={"Track Inventory?"}*/}
                    {/*        className={"fad fa-inventory ms-md-2 " + (hasInventory ? "text-primary" : "text-muted")}></i>*/}
                    {/*</span>*/}
                    {!this.props.supplierModel.has_warehouses ? null : (
                        <span className={"col-auto .g-0 item-has-warehouses"}>
                            <i
                                title={"Warehouses?"}
                                className={"fad fa-warehouse ms-md-2 " + (hasWarehouses ? "text-primary" : "text-muted")}></i>
                        </span>
                    )}
                    {this.props.supplierModel.has_product_sources && !row.is_alternate_source ? (
                        <span className={"item-has-alternate-sourcing"}>
                            <i
                                className={"fad fa-share-alt ms-md-2 " + (hasAlternateSourcing ? "text-primary" : "text-muted")}
                                title={"Has Alternate Sourcing?"}
                            />
                        </span>
                    ) : null}
                    {this.props.supplierModel.has_product_sources && row.is_alternate_source ? (
                        <span className={"item-is-alternate-source"}>
                            <i className={"fad fa-exchange-alt ms-md-2 text-primary"} title={"Is Alternate Source"} />
                        </span>
                    ) : null}
                    {hasWayfair ? (
                        <span className={"ms-1 col-auto .g-0"}>
                            <img src={wayfairIcon} title={"Wayfair Item"} height={"16"} />
                        </span>
                    ) : null}
                    {this.props.supplierModel.has_child_items ? (
                        <span className={""}>
                            <i
                                className={"fa-duotone fa-shapes ms-1 " + (row.has_child_items ? "text-info" : "text-muted")}
                                title={"Child Items?"}
                            />
                        </span>
                    ) : null}
                </div>
            );
        }
    };

    renderActiveCol = (active: boolean) => {
        return (
            <div className={"text-center " + (active ? "bluish-green" : "text-danger")}>
                <span className={"far fa-check-circle"} />
            </div>
        );
    };

    renderCategoryCol = (row: ICatalog_ItemUI, index: number) => {
        let categoryStr: any = ``;

        if (row.CategoryHierarchy) {
            categoryStr = row.CategoryHierarchy.map((category, index) => {
                if (index === row.CategoryHierarchy!.length - 1) {
                    return <span key={category.guid}>{category.name}</span>;
                } else {
                    return (
                        <span key={category.guid}>
                            {category.name} <i className={"far fa-arrow-right fa-xs"} />{" "}
                        </span>
                    );
                }
            });
        }

        return <div>{categoryStr}</div>;
    };

    renderTypeCol = (row: ICatalog_ItemUI, index: number) => {
        let typeStr: any = ``;

        if (row.is_kit) {
            typeStr = "kit";
        } else if (row.is_product_group) {
            typeStr = "product_group";
        } else if (row.has_inventory) {
            typeStr = "inventory";
        } else {
            typeStr = "non_inventory";
        }

        let leftIconClass = "";

        if (row.is_kit && row.is_advanced_kit && !row.is_kit_builder) {
            leftIconClass = "fad fa-flask text-success";
        } else if (row.is_kit && row.is_kit_builder) {
            leftIconClass = "fad fa-flask-gear text-warning";
        }

        return (
            <div>
                <OwLabel title={typeStr} leftIconClass={leftIconClass} />
            </div>
        );
    };

    renderSkuCol = (row: ICatalog_ItemUI) => {
        return (
            <div>
                <div>{row.sku}</div>
                {row.is_ordered_on_demand ? <OwPill title={"ordered_on_demand"} className={"text-small no-wrap"} /> : null}
            </div>
        );
    };

    renderInventoryCol = (row: ICatalog_ItemUI) => {
        if (row.has_inventory) {
            return <div>{row.qty_on_hand}</div>;
        } else {
            return null;
        }
    };

    /**
     * Render the short description column
     * @param row
     */
    renderShortDescriptionCol = (row: ICatalog_ItemUI) => {
        if (row.short_description) {
            return <div className={"pre-wrap"} dangerouslySetInnerHTML={{ __html: row.short_description }}></div>;
        } else {
            return null;
        }
    };

    renderDescriptionCol = (row: ICatalog_ItemUI) => {
        if (row.description) {
            return <div className={"pre-wrap"} dangerouslySetInnerHTML={{ __html: row.description }}></div>;
        } else {
            return null;
        }
    };

    renderMsrpCol = (row: ICatalog_ItemUI) => {
        if (row.msrp && _.isNumber(row.msrp)) {
            return (
                <NumericFormat
                    value={Number(row.msrp)}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            );
        }
    };

    renderMapCol = (row: ICatalog_ItemUI) => {
        if (row.map) {
            return (
                <NumericFormat
                    value={Number(row.map)}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            );
        }
    };

    renderPriceGroupCol = (row: ICatalog_ItemUI, index: number, priceGroup: IPrice_Group) => {
        const pricing = row.pricing;

        if (pricing) {
            const priceGroupValue = pricing[priceGroup.value] || 0;

            if (priceGroupValue === "N/A") {
                return <div>N/A</div>;
            } else {
                if (row.has_price_bands) {
                    return (
                        <PriceBandPriceDisplay
                            bands={(row.Price_Bands || {})[priceGroup.value] || []}
                            currency={this.state.catalogModel?.Currency}
                        />
                    );
                } else {
                    return HelperService.formatCurrency({
                        value: Number(priceGroupValue),
                        currency: this.state.catalogModel?.Currency?.name || "USD",
                        precision: this.props.supplierModel.pricing_precision || 2,
                    });
                }
            }
        } else {
            return <div></div>;
        }
    };

    renderUnitOfMeasurementCol = (row: ICatalog_ItemUI) => {
        if (row.Base_Unit) {
            return _.get(row, "Base_Unit.unit_abbr", "");
        } else {
            return _.get(row, "Unit_Of_Measurement.abbreviation", "");
        }
    };

    renderIntegrationsCol = (row: ICatalog_ItemUI) => {
        return (
            <IntegrationsConnectedBar
                squareConnected={false}
                shipstationConnected={false}
                zohoConnected={false}
                wooCommerceConnected={row.woocommerce_product_id}
                supplierModel={this.props.supplierModel}
                qboConnected={row.qbo_item_id}
                qbdConnected={!!row.qbd_ListID}
                shopifyConnected={!!row.shopify_id}
                fishbowlConnected={!!row.fishbowl_id}
                openCartConnected={!!row.opencart_product_id}
                xeroConnected={!!row.xero_item_id}
                position={"center"}
                showIntegrations={{
                    quickbooksDesktop: true,
                    quickbooksOnline: true,
                    shipstation: false,
                    square: true,
                    zoho: false,
                    wooCommerce: true,
                    shopify: true,
                    fishbowl: true,
                    opencart: true,
                    xero: true,
                }}
            />
        );
    };

    getQbdSelectableOptions = () => {
        let qbdSelectableOptions = this.state.qbdSelectableOptions;

        if (this.props.supplierModel.Supplier_Integration.has_qbd) {
            if (this.props.supplierModel.Supplier_Integration.qbd_CatalogItems) {
                qbdSelectableOptions = JSON.parse(this.props.supplierModel.Supplier_Integration.qbd_CatalogItems);
            }
        }

        return qbdSelectableOptions;
    };

    setupQuickBooksDesktop = () => {};

    pushQBDItems = () => {
        const payload: IQBDPushItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.QBDPushItems, payload);

        this.setState({
            qbdItemSyncActive: true,
        });
    };

    onQBDPushItems = (data: IOnQBDPushItemsDTO) => {
        const notification: INotification = {
            message: "successfully_scheduled_items_push",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            qbdItemSyncActive: false,
        });
    };

    closeModal = (refresh?: boolean) => {
        this.setState({
            modalIsOpen: false,
            modalComponent: null,
        });

        if (refresh) {
            this.getCatalogItems();
        }
    };

    showQbdItemSyncPriceGroupSelectionModal = () => {
        if (!this.props.supplierModel.Supplier_Integration.qbd_has_price_levels && this.state.catalogModel) {
            const modalComponent = (
                <QBDItemSyncPriceGroupSelectionModal
                    closeModalFn={this.closeModal}
                    startFn={this.qbdAutoConnectItems}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    priceGroups={this.state.priceGroups || []}
                />
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        } else {
            this.qbdAutoConnectItems();
        }
    };

    qbdAutoConnectItems = (selectedPriceGroupGuid?: string) => {
        const payload: IQBDCreateCatalogItemsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
            updateExisting: true,
        };

        if (selectedPriceGroupGuid) {
            payload.priceGroupGuid = selectedPriceGroupGuid;
        }

        this.props.socket.emit(EndpointsEnum.QBDCreateCatalogItems, payload);

        this.setState({
            qbdItemSyncActive: true,
            // We need to close any open modal because of the modal if no price lists in QBD being used.
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    onQbdCreateCatalogItems = (data: IOnQBDCreateCatalogItemsDTO) => {
        this.setState({
            qbdItemSyncActive: false,
        });
    };

    openQuickBooksMapping = () => {
        this.setState({
            qbdMapperVisible: true,
        });
    };

    openOrderRowConfigModal = () => {
        this.setState({
            showOrderRowConfig: true,
        });
    };

    openInventoryRowConfigModal = () => {
        this.setState({
            showInventoryRowConfig: true,
        });
    };

    toggleOrderRowConfigModal = () => {
        this.setState({
            showOrderRowConfig: !this.state.showOrderRowConfig,
        });
    };

    toggleInventoryRowConfigModal = () => {
        this.setState({
            showInventoryRowConfig: !this.state.showInventoryRowConfig,
        });
    };

    toggleButtonActive = (title: string) => {
        const actions = this.state.actions;

        if (!actions) {
            return;
        }

        for (const action of actions) {
            if (action.name === title) {
                action.isActive = !action.isActive;
            }
        }

        this.setState({ actions });
    };

    loadCatalogOverview = () => {
        this.getCatalog();
        // this.getCatalogItems(); // These get emitted automatically by the search filter bar on load.
        this.getPriceGroups();
    };

    getCatalog = () => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
        };

        this.props.socket.emit("getCatalog", payload);
    };

    onGetCatalog = (data: any) => {
        this.setState({
            catalogModel: data.catalog,
        });
    };

    onCreatePriceGroup = (data: any) => {
        this.props.toggleSidebar(false);
        this.props.setActivityIndicator(false);
        this.props.notifyFn(null, {
            message: "Created Price Groups",
            level: "success",
        });

        this.setState(
            {
                createPriceGroups: false,
            },
            () => {
                if (!this.state.createPriceGroups && !this.state.updatePriceGroups) {
                    this.loadCatalogOverview();
                }
            }
        );
    };

    onUpdatePriceGroup = (data: any) => {
        this.props.toggleSidebar(false);
        this.props.setActivityIndicator(false);
        this.props.notifyFn(null, {
            message: "Updated Price Groups",
            level: "success",
        });

        this.setState(
            {
                updatePriceGroups: false,
            },
            () => {
                if (!this.state.createPriceGroups && !this.state.updatePriceGroups) {
                    this.loadCatalogOverview();
                }
            }
        );
    };

    reloadCatalogItems = () => {
        this.getCatalogItems(this.state.queryString);
    };

    getCatalogItems = (_queryString?: any, skipTotalCount?: boolean, categoryGuid?: string) => {
        const _skipTotalCount = skipTotalCount;

        if (!this.props.userModel || !this.props.supplierModel) {
            return;
        }

        const queryString = _queryString || this.state.queryString;

        const data: IGetCatalogItemsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
            queryString,
            categoryGuid,
            limit: this.state.limit,
            offset: this.state.offset,
            skipTotalCount: _skipTotalCount,
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemGetCatalogItems, data);

        this.setState({
            isLoading: true,
            isDataFetching: true,
        });
    };

    getPriceGroups = () => {
        const data = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.state.catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, data);
    };

    onGetCatalogItems = (data: IOnGetCatalogItemsDTO) => {
        const catalog_items = data.catalog_items as ICatalog_ItemUI[];

        const catalogItems = _.map(catalog_items, (catalog_item) => {
            catalog_item.isSaved = true;

            return catalog_item;
        });

        // console.log(catalogItems);
        const state: any = {
            dataFetched: true,
            catalog_items: catalogItems,
            isLoading: false,
            isDataFetching: false,
            isInitialData: false,
        };

        if (data.totalCatalogItems) {
            state.totalCatalogItems = data.totalCatalogItems;
        }

        this.setState(state, () => {
            this.props.setActivityIndicator(false);
            this.setupQuickBooksDesktop();
        });
    };

    paginationChanged = (offset: number, limit: number) => {
        const origOffset = this.state.offset;
        const origLimit = this.state.limit;

        this.setState(
            {
                offset,
                limit,
            },
            () => {
                if (origOffset !== offset || origLimit !== limit) {
                    this.getCatalogItems(this.state.queryString, true);
                }
            }
        );
    };

    filterCatalogItems = (queryString?: string, reset?: boolean, _offset?: number, categoryGuid?: string) => {
        const state: any = {
            queryString,
            offset: 0,
        };

        if (reset) {
            state.queryString = `?order_dir=${SortOrderEnum.ASC}&order_by=name`;

            state.sortDir = SortOrderEnum.ASC;
            state.sortCol = "name";
        }

        this.setState(state, () => {
            this.getCatalogItems(queryString, undefined, reset ? undefined : categoryGuid);
        });
    };

    getVendorSources = () => {
        const payload: IGetVendorSourcesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            limit: 250,
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSources, payload);
    };

    onGetVendorSources = (data: IOnGetVendorSourcesDTO) => {
        this.setState({
            vendorSources: data.vendorSources,
        });
    };

    toggleSidebar = (refreshData?: boolean) => {
        if (refreshData) {
            this.getCatalogItems(this.state.queryString);
        }

        this.props.toggleSidebar();
    };

    getSidebarComponent = (catalog_item: any) => {
        return (
            <CreateCatalogItemSidebar
                catalogModel={this.state.catalogModel!}
                catalogGuid={this.state.catalogGuid}
                priceGroups={this.state.priceGroups}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                catalog_item={catalog_item}
                cancel={this.toggleSidebar}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                vendorSources={this.state.vendorSources}
            />
        );
    };

    openCatalogItemSidebar = (catalog_item: any, index?: number) => {
        // console.log('Toggle Sidebar', shipment, index);
        const sidebarComp = this.getSidebarComponent(catalog_item);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();
    };

    getPriceGroupSidebarComponent = () => {
        return (
            <PriceGroupSidebar
                saveFn={this.savePriceGroups}
                priceGroups={this.state.priceGroups}
                cancel={this.props.toggleSidebar}
                clearData={this.state.clearPriceGroupData}
                deleteFn={this.deletePriceGroup}
            />
        );
    };

    openPriceGroupsSidebar = () => {
        const sidebarComp = this.getPriceGroupSidebarComponent();
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();
    };

    getCategoriesSidebarComponent = (isHomeCategories?: boolean) => {
        if (!this.state.catalogModel) {
            return null;
        }

        return (
            <CategorySidebar
                notifyFn={this.props.notifyFn}
                saveFn={this.saveCategories}
                categories={this.state.categories}
                cancel={this.props.toggleSidebar}
                clearData={this.state.clearCategoryData}
                socket={this.props.socket}
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                catalogModel={this.state.catalogModel}
                priceGroups={this.state.priceGroups}
                isHomeCategories={isHomeCategories}
            />
        );
    };

    saveCategories = (data: any) => {
        console.log("saveCategories", data);
    };

    openHomeCategoriesSidebar = () => {
        if (!this.state.catalogModel) {
            return null;
        }

        const sidebarComp = this.getCategoriesSidebarComponent(true);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();
    };

    openCategoriesSidebar = () => {
        if (!this.state.catalogModel) {
            return null;
        }

        const sidebarComp = this.getCategoriesSidebarComponent();
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar();
    };

    deletePriceGroup = (priceGroup: IPrice_Group) => {
        this.props.setActivityIndicator(true);

        const payload: ICatalogDeletePriceGroupDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            priceGroupGuid: priceGroup.guid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsDeletePriceGroup, payload);
    };

    onDeletePriceGroup = (data: ICatalogOnDeletePriceGroupDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_price_group",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.props.toggleSidebar(false);
        this.props.setSidebarComponent(null);

        this.props.setActivityIndicator(false);

        this.getPriceGroups();
        this.loadCatalogOverview();
    };

    /**
     * TODO refactor this monstrosity.
     *
     * @param data
     */
    savePriceGroups = (data: any) => {
        console.log("savePriceGroups", data);

        const updatePriceGroups: any[] = [];
        const createPriceGroups: any[] = [];
        let isSaving = false;

        _.each(data, (priceGroup) => {
            if (priceGroup.isUpdated && !priceGroup.isNew) {
                updatePriceGroups.push({
                    guid: priceGroup.guid,
                    value: priceGroup.value,
                });
            } else if (priceGroup.isNew) {
                createPriceGroups.push({ value: priceGroup.value });
            }
        });

        if (createPriceGroups.length) {
            const payload = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: this.state.catalogGuid,
                priceGroups: createPriceGroups,
            };

            console.log("createPriceGroups", payload);

            this.props.socket.emit(EndpointsEnum.CatalogsCreatePriceGroup, payload);

            isSaving = true;
        }

        if (updatePriceGroups.length) {
            const payload = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: this.state.catalogGuid,
                priceGroups: updatePriceGroups,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsUpdatePriceGroup, payload);

            isSaving = true;
        }

        if (isSaving) {
            this.props.setActivityIndicator(true);
        }

        this.setState({
            createPriceGroups: createPriceGroups.length,
            updatePriceGroups: updatePriceGroups.length,
        } as any);

        // TODO on saving the price gorup data, we need to
        // set the this.state.clearPriceGroupData to true and
        // after the new price group data is updated, update the state
        // for clear to false.
        // Reload the catalog data at the smae time, as it should
        // include the newly augmented pricing json structure
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState(
            {
                priceGroups: data.priceGroups,
            },
            () => {
                this.setupTableColumns();
            }
        );
    };

    getPriceGroupHeaders = () => {
        const firstCatalogItem = _.get(this.state, "catalog_items[0]", {} as ICatalog_ItemUI);

        const pricing = firstCatalogItem.pricing;

        let priceGroupsCount = 0;
        let priceGroups;

        if (!_.isNil(pricing)) {
            priceGroups = Object.keys(pricing);
            priceGroupsCount = priceGroups.length;
        }

        if (!priceGroupsCount) {
            return <FormattedMessage id="price_per_unit" defaultMessage="Price / Unit" description="Price / Unit Title" />;
        } else {
            return _.map(priceGroups, (priceGroup: any, index: number) => {
                return (
                    <th key={priceGroup.guid || index} className={"text-center"} style={{ width: "7rem" }}>
                        <OwLabel title={_.startCase(priceGroup)} skipTranslate={true} rowHasSort={true} />
                    </th>
                );
            });
        }
    };

    toggleSortDir = (sortCol: string, sortOrder: SortOrderEnum) => {
        this.setState({ sortDir: sortOrder, sortCol }, () => {
            // console.log('toggleSortDir: ', this.state.sortDir, this.state.sortCol);
            // this.reloadCatalogItems();
            // this.getCatalogItems(this.state.queryString, true);
        });
    };

    toggleSmallTable = (isSmallTable: boolean) => {
        this.setState({
            isSmallTable,
            isPhotoView: false,
        });
    };

    togglePhotoView = (isPhotoView: boolean) => {
        this.setState({
            isPhotoView,
            isSmallTable: false,
        });
    };

    setColumns = (columns: IColumns) => {
        this.setState(
            {
                columns,
            },
            () => {
                // console.log("columns", columns);
                this.setupTableColumns();
            }
        );
    };

    qbdDataMapperSave = (items: IDataMapperSaveItem[]) => {
        console.log("qbdDataMapperSave", items);
        const payload: IQBDMapperDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            resource: ResourceTypesEnum.CATALOG_ITEM,
            items: _.map(items, (item) => {
                return {
                    resourceGuid: item.staticValue,
                    mapValues: {
                        qbd_ListID: item.selectedItem ? item.selectedItem.ListID : null,
                    },
                };
            }),
        };

        this.props.socket.emit("qbdMapper", payload);
    };

    onQbdMapper = (data: IOnQBDMapperDTO) => {
        this.setState(
            {
                qbdMapperVisible: false,
            },
            () => {
                this.getCatalogItems();
            }
        );
    };

    qbdDataMapperCancel = () => {
        this.setState({
            qbdMapperVisible: false,
        });
    };

    saveColumnsAsDefault = (columns: IColumns) => {
        const orderCols: { [key: string]: boolean } = {};

        for (const prop of Object.keys(columns)) {
            orderCols[prop] = columns[prop].isChecked;
        }

        const currentToken = UserService.getCurrentToken(this.props.userModel);

        if (currentToken) {
            const payload: IUpdateTokenSettingsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                settings: {
                    catalog_cols: orderCols,
                },
                tokenGuid: currentToken.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenUpdateSettings, payload);
        }
    };

    onUpdateTokenSettings = (data: IOnUpdateUserSettingsDTO) => {
        const notification: INotification = {
            message: "successfully_saved_settings",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);
    };

    render() {
        return (
            <div className="CatalogOverview position-relative">
                {this.state.catalog_items.length && !this.state.isLoading ? (
                    <OwDataMapper
                        isVisible={this.state.qbdMapperVisible}
                        saveFn={this.qbdDataMapperSave}
                        cancelFn={this.qbdDataMapperCancel}
                        mainTitle={"catalog_item_mapper"}
                        staticTitle={"catalog_items"}
                        staticOptions={this.state.catalog_items}
                        staticValueProp={"guid"}
                        staticValueSelectedProp={"qbd_ListID"}
                        staticTitleProp={"name"}
                        staticSubTitleProp={"sku"}
                        selectableTitle={"quickbooks_items"}
                        selectableOptions={this.state.qbdSelectableOptions}
                        selectableValueProp={"ListID"}
                        selectableTitleProp={"Name"}
                    />
                ) : null}

                <div>
                    <Breadcrumbs className={"d-inline-flex"} navItems={this.state.navItems} />
                    {this.state.catalogModel ? " - " + this.state.catalogModel.name : ""}
                </div>

                <div className="row">
                    <div className="col-12 d-flex align-items-center justify-items-center flex-wrap mb-2 mb-md-0 w-100">
                        <OwTitle title={"catalog_items"} leftIconName={"fad fa-books"} />
                        <div className={"mt-md-0 d-flex justify-content-between flex-grow"}>
                            <div className={"align-self-center"}>
                                <OwButton
                                    id={"create"}
                                    className={"btn-warning ms-md-3 me-2 me-md-0"}
                                    title={"create"}
                                    leftIconClass={"fas fa-plus"}
                                    fn={this.openCatalogItemSidebar}
                                />
                            </div>
                        </div>
                        {this.state.qbdItemSyncActive ? <QBDItemsSyncStatus /> : null}
                    </div>
                </div>

                <div className="mb-2">
                    <SearchSection>
                        <CatalogItemFilter
                            searchFn={this.filterCatalogItems}
                            sortCol={this.state.sortCol}
                            sortDir={this.state.sortDir}
                            emitOnLoad={true}
                            offset={this.state.offset}
                            limit={this.state.limit}
                            catalogGuid={this.state.catalogGuid}
                        />
                    </SearchSection>
                </div>

                {this.props.isReadOnly ? null : (
                    <div className={"row mt-1 mb-1"}>
                        <div className={"col-12"}>
                            <OwActionBar
                                togglePhotoView={this.togglePhotoView}
                                toggleSmallTable={this.toggleSmallTable}
                                colToggledFn={this.setColumns}
                                columns={this.state.columns}
                                actions={this.state.actions}
                                totalValue={this.state.totalCatalogItems}
                                disabled={false}
                                saveAsDefaultsFn={this.saveColumnsAsDefault}
                            />
                        </div>
                    </div>
                )}

                {/* Inline Actions */}
                <div>
                    {this.state.showOrderRowConfig && this.state.catalogModel ? (
                        <OrderRowConfig
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            socket={this.props.socket}
                            catalogModel={this.state.catalogModel}
                            toggleOrderRowConfig={this.toggleOrderRowConfigModal}
                            notifyFn={this.props.notifyFn}
                        />
                    ) : null}
                </div>
                <div>
                    {this.state.showInventoryRowConfig && this.state.catalogModel ? (
                        <InventoryRowConfig
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            socket={this.props.socket}
                            catalogModel={this.state.catalogModel}
                            toggleInventoryRowConfig={this.toggleInventoryRowConfigModal}
                            notifyFn={this.props.notifyFn}
                        />
                    ) : null}
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className="table-responsive position-relative">
                            <ConfirmDeleteOverlayFn
                                targetElem={this.state.deleteElem}
                                handleConfirm={this.confirmDelete}
                                handleCancel={this.cancelDelete}
                                message={"confirm_delete"}
                                nestedParentElem={"catalog-item-table"}
                                skipMainView={true}
                            />

                            <OwTable
                                id={"catalog-item-table"}
                                columns={this.state.tableColumns}
                                dataSet={this.state.catalog_items}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                dataFetch={this.state.isDataFetching}
                                initialData={this.state.isInitialData}
                                currentSortCol={this.state.sortCol}
                                tableConfig={{
                                    tableStriped: true,
                                    tableSmall: this.state.isSmallTable,
                                    tableHasSort: true,
                                    alignHeadersMiddle: true,
                                }}
                                maintainTableHeight={true}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className={"col-12"}>
                        {this.state.catalog_items.length ? (
                            <PaginationBar
                                offset={this.state.offset}
                                limit={this.state.limit}
                                totalRecords={this.state.totalCatalogItems}
                                onPaginationChanged={this.paginationChanged}
                            />
                        ) : null}
                    </div>
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default CatalogOverview;
